
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SpaceTimeDistortionEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const spacing = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.2 / (layerIndex + 1);
            for (let x = x1; x <= x2; x += spacing) {
                ctx.beginPath();
                for (let y = y1; y <= y2; y += 20) {
                    const dist = Math.hypot(x, y);
                    const distortion = Math.sin(dist * 0.01 - curTime * 2) * 50 * scale / (dist * 0.01 + 1);
                    if (y === y1) ctx.moveTo(x + distortion, y + distortion);
                    else ctx.lineTo(x + distortion, y + distortion);
                }
                ctx.stroke();
            }
            for (let y = y1; y <= y2; y += spacing) {
                 ctx.beginPath();
                 for (let x = x1; x <= x2; x += 20) {
                     const dist = Math.hypot(x, y);
                     const distortion = Math.sin(dist * 0.01 - curTime * 2) * 50 * scale / (dist * 0.01 + 1);
                     if (x === x1) ctx.moveTo(x + distortion, y + distortion);
                     else ctx.lineTo(x + distortion, y + distortion);
                 }
                 ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
